module.exports = __webpack_public_path__ + "img/warningbig.552076de.png";